import React from "react";
import styled from "styled-components/macro";
import { IconButton } from "@mui/material";
import LinkExt from "../../components/other/LinkExt";
import { isDesktop } from "../../tools/device";

const Links = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  gap: 10px;
  a {
    display: inherit;
  }
  svg {
    background: ${({ theme }) => theme.duo.color.white};
  }
  button {
    width: 38px;
    height: 38px;
    border-radius: 100px;
    border: 1px solid ${({ theme }) => theme.duo.palette.blueLighter};
    background: ${({ theme }) => theme.duo.color.white};
    padding: 5px;
  }
  button:hover {
    background: ${({ theme }) => theme.duo.color.white};
  }
`;

const SocialIconImg = styled.img`
  width: 24px;
  height: 24px;
  display: block;
`;

const socialLinks = [
  {
    name: "facebook",
    url: isDesktop() ? "https://www.facebook.com/pg/DuoCardsCom" : "fb://page/107180174194369",
    alt: "Facebook"
  },
  {
    name: "instagram",
    url: "https://www.instagram.com/duocardscom",
    alt: "Instagram"
  },
  {
    name: "reddit",
    url: "https://www.reddit.com/r/DuoCards/",
    alt: "Reddit"
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/c/DuoCards",
    alt: "YouTube"
  },
  {
    name: "home",
    url: "https://www.duocards.com",
    alt: "DuoCards"
  }
];

export const SocialLinks: React.FC<{}> = () => {
  return (
    <Links>
      {socialLinks.map((item) => (
        <IconButton key={item.name}>
          <LinkExt href={item.url}>
            <SocialIconImg src={`https://cdn.duocards.com/img/${item.name}.png`} alt={item.alt} />
          </LinkExt>
        </IconButton>
      ))}
    </Links>
  );
};

// export const WebLinks: React.FC<{}> = () => {
//   return (
//     <Links>
//       <IconButton>
//         <LinkExt href="https://play.google.com/store/apps/details?id=com.duocards.app">
//           <ShopIcon />
//         </LinkExt>
//       </IconButton>
//       <IconButton>
//         <LinkExt href="https://apps.apple.com/us/app/duocards-learning-decks/id1508159917">
//           <AppleIcon />
//         </LinkExt>
//       </IconButton>
//     </Links>
//   );
// };
